<template>
  <div>
    <h1>Instructions</h1>
    <v-progress-circular indeterminate color="info" v-if="!instructions" />
    <v-alert :value="instructions && !instructions.length" type="info">No results</v-alert>
    <div v-if="instructions && instructions.length">
      <v-btn @click="download">View pdf</v-btn>
      <v-data-table
        :headers="headers"
        :items="modifiedInstructions"
        hide-actions
        class="elevation-1"
        :pagination.sync="pagination"
        :loading="loading"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <FileZ :file="props.item" />
            </td>
            <td>
              <Quote :quoteId="props.item.quoteId" />
            </td>
            <td>
              <span v-if="props.item.category">{{props.item.category.shortname}}</span>
            </td>
            <td>
              <div v-if="props.item.clients">
                <div v-for="client in props.item.clients" :key="client.id">
                  <EntityZ :entity="client" format="system" />
                </div>
              </div>
            </td>
            <td>
              <div v-if="props.item.subjectProperty">
                <EntityZ :entity="props.item.subjectProperty" />
              </div>
            </td>
            <td>
              <span v-if="props.item.department">{{props.item.department.name}}</span>
            </td>
            <td>
              <span v-if="props.item.lfs">true</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import FileZ from "@/components/link/FileZ";
import Quote from "@/components/link/Quote";
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Instructions",
  metaInfo() {
    return {
      title: "Instructions",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ, FileZ, Quote },
  computed: {
    modifiedInstructions() {
      if (!this.instructions) {
        return undefined;
      }
      const categoryMap = this.categories
        ? convertListOfObjectsToMap(this.categories, "id")
        : undefined;
      const departmentMap = this.departments
        ? convertListOfObjectsToMap(this.departments, "id")
        : undefined;
      return this.instructions.map(f => {
        const category =
          categoryMap && categoryMap[f.categoryId]
            ? categoryMap[f.categoryId]
            : undefined;
        const department =
          departmentMap && departmentMap[f.departmentId]
            ? departmentMap[f.departmentId]
            : undefined;
        const clients = this.clients ? this.clients[f.id] : undefined;
        const subjectProperty = this.subjectProperties
          ? this.subjectProperties[f.id]
          : undefined;
        const lfs = this.lfs ? this.lfs[f.id] : undefined;
        return { ...f, category, department, clients, subjectProperty, lfs };
      });
    }
  },
  data() {
    return {
      instructions: null,
      categories: null,
      departments: null,
      files: null,
      clients: null,
      subjectProperties: null,
      lfs: null,
      headers: [
        {
          text: "File",
          value: "file.referencelong"
        },
        {
          text: "Quote",
          value: "file.quoteid"
        },
        {
          text: "Category",
          value: "file.category.shortname"
        },
        {
          text: "Clients",
          value: "nagdate"
        },
        {
          text: "Property",
          value: "age"
        },
        {
          text: "Department",
          value: "file.department.name"
        },
        {
          text: "Lfs",
          value: "age"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: false,
        page: 1,
        rowsPerPage: -1
      },
      loading: false
    };
  },
  methods: {
    fetchInstructions() {
      nbmlaw
        .get("/cors/admin/file/instructions/diary", {
          params: { date: this.$route.query.date }
        })
        .then(response => {
          // console.log(response.data);
          this.instructions = response.data;
        })
        .catch(() => {});
    },
    fetchClients() {
      nbmlaw
        .get("/cors/admin/file/instructions/diary/clients", {
          params: { date: this.$route.query.date }
        })
        .then(response => {
          // console.log(response.data);
          this.clients = response.data;
        })
        .catch(() => {});
    },
    fetchSubjectProperties() {
      nbmlaw
        .get("/cors/admin/file/instructions/diary/subjectProperties", {
          params: { date: this.$route.query.date }
        })
        .then(response => {
          // console.log(response.data);
          this.subjectProperties = response.data;
        })
        .catch(() => {});
    },
    fetchLfs() {
      nbmlaw
        .get("/cors/admin/file/instructions/diary/lfs", {
          params: { date: this.$route.query.date }
        })
        .then(response => {
          // console.log(response.data);
          this.lfs = response.data;
        })
        .catch(() => {});
    },
    fetchCategories() {
      nbmlaw
        .get(`/cors/admin/file/categories`)
        .then(response => {
          // console.log(response.data);
          this.categories = response.data;
        })
        .catch(() => {});
    },
    fetchDepartments() {
      nbmlaw
        .get(`/cors/admin/file/departments`)
        .then(response => {
          // console.log(response.data);
          this.departments = response.data;
        })
        .catch(() => {});
    },
    download() {
      const date = this.$route.query.date;
      const baseurl = `${process.env.VUE_APP_CT_URL}/cors/admin/file/instructions/diary`;
      const url = date ? `${baseurl}/${date}/pdf` : baseurl;
      window.open(url, "_blank");
    },
    fetchAll() {
      this.fetchInstructions();
      this.fetchClients();
      this.fetchSubjectProperties();
      this.fetchLfs();
    }
  },
  watch: {
    "$route.query.date": {
      immediate: true,
      handler() {
        this.fetchAll();
      }
    }
  },
  created() {
    this.fetchCategories();
    this.fetchDepartments();
  }
};
</script>

<style>
</style>
